module.exports = __webpack_public_path__ + "img/icon-user.7fd7d243.svg";